/**
 * HERMES · Word-level line diff util.
 * Retorna array de segments: { type: "eq" | "add" | "del", text: string }
 * Algoritmo LCS clássico O(n*m) sobre linhas; suficiente para peças jurídicas
 * de até algumas centenas de linhas. Sem dependências externas.
 */

/**
 * @param {string} a - texto original
 * @param {string} b - texto atual
 * @returns {{lines: Array<{type:"eq"|"add"|"del", text:string}>, stats: {additions:number, deletions:number, unchanged:number}}}
 */
export function diffLines(a, b) {
  const aLines = (a || "").split("\n");
  const bLines = (b || "").split("\n");
  const n = aLines.length, m = bLines.length;
  // LCS table
  const dp = Array.from({ length: n + 1 }, () => new Uint16Array(m + 1));
  for (let i = n - 1; i >= 0; i--) {
    for (let j = m - 1; j >= 0; j--) {
      dp[i][j] = aLines[i] === bLines[j]
        ? dp[i + 1][j + 1] + 1
        : Math.max(dp[i + 1][j], dp[i][j + 1]);
    }
  }
  const lines = [];
  const stats = { additions: 0, deletions: 0, unchanged: 0 };
  let i = 0, j = 0;
  while (i < n && j < m) {
    if (aLines[i] === bLines[j]) {
      lines.push({ type: "eq", text: aLines[i] });
      stats.unchanged++; i++; j++;
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      lines.push({ type: "del", text: aLines[i] });
      stats.deletions++; i++;
    } else {
      lines.push({ type: "add", text: bLines[j] });
      stats.additions++; j++;
    }
  }
  while (i < n) { lines.push({ type: "del", text: aLines[i++] }); stats.deletions++; }
  while (j < m) { lines.push({ type: "add", text: bLines[j++] }); stats.additions++; }
  return { lines, stats };
}
